import { assign } from 'xstate';

const handleError = assign((context, event) => {
  logger.error('[@fingermarkglobal/cbq-ecr] Error', event.data?.message);

  return {
    ...context,
    message: event.data?.message, // catches `Error` objects that are thrown as it cant automatically destrucutre the `message` prop
    ...event.data,
  };
});

export { handleError };
